<template>
	<div class="skill-search-component">
		<div class="select-bar-block">
			<multiselect v-model="skillSelected" placeholder="Select a skill" :options="listSkills" label="title" :searchable="true" track-by="title" :multiple="false" group-values="skills_search" group-label="title" :loading="isLoading" @select="openLink">
				<template #placeholder>
					<div class="placeholder" v-html="placeholder"></div>
				</template>
			</multiselect>
		</div><!-- 
		<div class="action-btn">
			<a :href="link" target="_blank" v-if="skillSelected && skillSelected.id > 0 && link">Go</a>
		</div> -->
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect';
	export default {
		props: {
			grade: {default: null},
			placeholder: {default: 'Which skill do you want to practice today?'}
		},
		name: 'skillSearch',
		components: { Multiselect },
		data() {
			return {
				listSkills: [],
				skillSelected: null,
				isLoading: false,
			}
		},
		created() {
			this.loadSkills(this.grade);
		},
		computed: {
			link() {
				let link = null, option = this.skillSelected;
				switch (option.resource_type) {
					case 'skill':
						link = route('grade.topic.skill.show', {grade: option.grade_link, grade_topic: option.grade_topic_link, skill: option.link})
						break;
					case 'topic':
						link = route('topic.show', option)
						break;
					case 'grade':
						link = route('grade.show', option)
						break;
					case 'grade_topic':
						link = route('grade-topic.show', {grade: option.grade_link, gradeTopic: option})
						break;
					default:
						link = option.link;
						break;
				}
				return link;
			}
		},
		methods: {
			async loadSkills(grade) {
				this.isLoading = true;
				try {
					let skills = await axios.get(route('skills.index', grade));
					console.log("skills loaded:", skills.data);
					this.listSkills = JSON.parse(JSON.stringify(skills.data));
				} catch(e) {
					console.log("Error whiile loading skills:", e);
				} finally {
					this.isLoading = false;
					// statements
				}
			},
			openLink(option, id) {
				console.log("opened:", option, "which has id:", id);
				let link = null;
				switch (option.resource_type) {
					case 'skill':
						link = route('grade.topic.skill.show', {grade: option.grade_link, grade_topic: option.grade_topic_link, skill: option.link})
						break;
					case 'topic':
						link = route('topic.show', option)
						break;
					case 'grade':
						link = route('grade.show', option)
						break;
					case 'grade_topic':
						link = route('grade-topic.show', {grade: option.grade_link, gradeTopic: option})
						break;
					default:
						link = option.link;
						break;
				}
				window.open(link, '_blank');
			}
		}
	}
</script>

<style scoped>
	.placeholder {
/*		color: #9a9d9e;*/
	}
</style>